import http from '@/support/plugin/axios'

export const 

//Faz submit da review
updateReviewByIdAndCompanyIdAndContactId = ( companyId, contactId, id, messageObj ) => http.put(`companies/${companyId}/contacts/${contactId}/reviews/${id}`, messageObj),

//Pega todos os improvements
getAllReviewImprovements = () => http.get(`reviews/improvements`)